import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { setGlobalErrors } from '@/store/globalErrors/globalErrors.actions';

export const mapDispatchToProps = (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => ({
  globalErrorsSet: (errors: unknown) => dispatch(setGlobalErrors(errors)),
});

export default connect(null, mapDispatchToProps);
